"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.performanceUpdate = exports.performanceSuccess = exports.performanceSoftDelete = exports.performanceRestoreSoftDelete = exports.performanceReset = exports.performanceListSoftRestoreDelete = exports.performanceListByIdYear = exports.performanceList = exports.performanceError = exports.performanceDeleteAll = exports.performanceDelete = exports.performanceCreate = exports.performanceBulkRestore = exports.performanceBulkHardDelete = void 0;
var _performance = require("./performance.constant");
// common success
var performanceSuccess = function performanceSuccess(actionType, data) {
  return {
    type: _performance.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.performanceSuccess = performanceSuccess;
var performanceError = function performanceError(actionType, error) {
  return {
    type: _performance.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * search performance list with id and year
 * @param payload
 * @returns api response
 * @description this function used to search performance with id and year.
 */
exports.performanceError = performanceError;
var performanceListByIdYear = function performanceListByIdYear(data) {
  return {
    type: _performance.actionTypes.LIST_BY_ID_YEAR,
    payload: data
  };
};

/**
 * performance list with params
 * @param payload
 * @returns api response
 * @description this function used to performance list with params.
 */
exports.performanceListByIdYear = performanceListByIdYear;
var performanceList = function performanceList(data) {
  return {
    type: _performance.actionTypes.LIST,
    payload: data
  };
};

/**
 * performance create
 * @param payload
 * @returns api response
 * @description this function used to performance create given inputs.
 */
exports.performanceList = performanceList;
var performanceCreate = function performanceCreate(data) {
  return {
    type: _performance.actionTypes.CREATE,
    payload: data
  };
};

/**
 * performance update
 * @param payload
 * @returns api response
 * @description this function used to update performance given inputs.
 */
exports.performanceCreate = performanceCreate;
var performanceUpdate = function performanceUpdate(data) {
  return {
    type: _performance.actionTypes.UPDATE,
    payload: data
  };
};

/**
 * performance delete
 * @param payload
 * @returns api response
 * @description this function used to delete performance of given params.
 */
exports.performanceUpdate = performanceUpdate;
var performanceDelete = function performanceDelete(data) {
  return {
    type: _performance.actionTypes.DELETE,
    payload: data
  };
};

/**
 * performance delete
 * @param payload
 * @returns api response
 * @description this function used to delete all performance.
 */
exports.performanceDelete = performanceDelete;
var performanceDeleteAll = function performanceDeleteAll(data) {
  return {
    type: _performance.actionTypes.DELETE_ALL,
    payload: data
  };
};

/**
 * performance reset
 * @param payload
 * @returns api response
 * @description this function used to reset performance.
 */
exports.performanceDeleteAll = performanceDeleteAll;
var performanceReset = function performanceReset(data) {
  return {
    type: _performance.actionTypes.RESET,
    payload: data
  };
};
exports.performanceReset = performanceReset;
var performanceSoftDelete = function performanceSoftDelete(data) {
  return {
    type: _performance.actionTypes.SOFT_DELETE,
    payload: data
  };
};
exports.performanceSoftDelete = performanceSoftDelete;
var performanceRestoreSoftDelete = function performanceRestoreSoftDelete(data) {
  return {
    type: _performance.actionTypes.RESTORE_SOFT_DELETE,
    payload: data
  };
};
exports.performanceRestoreSoftDelete = performanceRestoreSoftDelete;
var performanceListSoftRestoreDelete = function performanceListSoftRestoreDelete(data) {
  return {
    type: _performance.actionTypes.LIST_RESTORE_SOFT_DELETE,
    payload: data
  };
};
exports.performanceListSoftRestoreDelete = performanceListSoftRestoreDelete;
var performanceBulkRestore = function performanceBulkRestore(data) {
  return {
    type: _performance.actionTypes.BULK_RESTORE,
    payload: data
  };
};
exports.performanceBulkRestore = performanceBulkRestore;
var performanceBulkHardDelete = function performanceBulkHardDelete(data) {
  return {
    type: _performance.actionTypes.BULK_HARD_DELETE,
    payload: data
  };
};
exports.performanceBulkHardDelete = performanceBulkHardDelete;